module.exports = __webpack_public_path__ + "img/login.02009d55.jpeg";